import { DateTime } from 'luxon';

export const validateISODateFormat = (dateValue: string): boolean => {
    if (!dateValue) return false;

    try {
        // Attempt to parse the date string using Luxon with the specified format
        const parsedDate = DateTime.fromISO(dateValue);

        // Check if the parsed date is valid and matches the input string
        return parsedDate.isValid && (parsedDate.toISO() === dateValue || parsedDate.toISODate() === dateValue);
    } catch (error) {
        return false; // If parsing fails, the format is invalid
    }
};
